// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import IAward from "@/models/IAward";

export class State extends CrudState {
  dataList: Array<IAward> = [];
  dataItem: IAward | null = null;
}
